export default function StructuredData({ data }: { data: object }) {
  return (
    <script data-type="schema" type="application/ld+json">
      {JSON.stringify(data)}
    </script>
  );
}
